import { render } from "lit-html"
import { US_STATES_TO_ABBREV } from "../constants"

import { AutocompleteText } from "./autocomplete-text"

export const GEOCODE_ENDPOINT = `/locations/geocode/autocomplete/api/?query=`

export const onResults = (res) =>
  res.features.map((r) => {
    const { address } = r.properties
    return {
      ...address,
      value:
        [address.streetNumber, address.streetName].filter(Boolean).join(" ") ||
        address.formattedAddress,
      label: address.formattedAddress,
    }
  })

export const getStateAbbrev = (state) =>
  state.shortName || US_STATES_TO_ABBREV[state.name] || ``

export default function GeocodeInput(el, parentForm = null) {
  const mount = el.parentNode

  render(
    AutocompleteText({
      name: el.name,
      value: el.value || ``,
      required: el.hasAttribute("required"),
      placeholder:
        el.getAttribute("placeholder") || el.getAttribute("aria-label") || ``,
      endpoint: GEOCODE_ENDPOINT,
      onResults,
      onSelect: (item) => {
        const queryContext = parentForm || document

        const $cityInput = queryContext.querySelector(`input[name="city"]`)
        if ($cityInput) $cityInput.value = item.locality || ""

        const $stateSelect = queryContext.querySelector(`select[name="state"]`)
        if ($stateSelect)
          $stateSelect.value = item.adminDistricts
            ? getStateAbbrev(item.adminDistricts[0])
            : ``

        const $zipInput = queryContext.querySelector(`input[name="zip_code"]`)
        if ($zipInput) $zipInput.value = item.postalCode || ""
      },
    }),
    mount
  )
}
